export default [
    {
        key: 'data',
        components: [
            {
                label: 'Default payment method for single payments',
                widget: 'choicesjs',
                uniqueOptions: true,
                tableView: true,
                dataSrc: 'custom',
                data: {
                    custom: "const _frequency = 'once';\n\nconst enabledPaymentMethods = data.available_payment_methods_list.filter(method => {\n  const frequencies = method.frequencies || ['once'];\n  \n  if(!method.enabled) return false;\n  if(!frequencies.includes(_frequency)) return false;\n  \n  return true;\n}).map(method => {\n  return { \n    id: method.name.toLowerCase().replace(' ', ''),\n    label: method.label, name: method.name\n  };\n});\n\nvalues = enabledPaymentMethods;"
                },
                redrawOn: 'data',
                validate: {
                    custom: "const _frequency = 'once';\n\nconst enabledPaymentMethods = data.available_payment_methods_list.filter(method => {\n  const frequencies = method.frequencies || ['once'];\n\n  if (!method.enabled) return false;\n  if (!frequencies.includes(_frequency)) return false;\n\n  return true;\n}).map(method => {\n  return {\n    id: method.name.toLowerCase().replace(' ', ''),\n    label: method.label,\n    name: method.name\n  };\n});\n\nif (!_.isEmpty(enabledPaymentMethods)) {\n  if (!data.default_payment_method_once) { \n    valid = \"A payment method is required.\";\n    return valid;\n  }\n  \n  if (!enabledPaymentMethods.some(method => method.id === data.default_payment_method_once)) {\n    valid = `The selected payment method is not available within the frequency: ${_frequency} .`;\n    return valid;\n  }\n\n  valid = true;\n  return valid;\n}\n\nvalid = true;"
                },
                customConditional: "const _frequency = 'once';\n\nconst enabledPaymentMethods = data.available_payment_methods_list.filter(method => {\n  const frequencies = method.frequencies || ['once'];\n\n  if (!method.enabled) return false;\n  if (!frequencies.includes(_frequency)) return false;\n\n  return true;\n}).map(method => {\n  return {\n    id: method.name.toLowerCase().replace(' ', ''),\n    label: method.label,\n    name: method.name\n  };\n});\n\nshow = !_.isEmpty(enabledPaymentMethods);",
                template: '<span>{{ item.label }} ({{ item.name }})</span>',
                dataType: 'string',
                valueProperty: 'id',
                refreshOn: 'available_payment_methods_list',
                clearOnHide: true,
                key: 'default_payment_method_once',
                type: 'select',
                input: true
            },
            {
                label: 'Default payment method for monthly payments',
                widget: 'choicesjs',
                uniqueOptions: true,
                tableView: true,
                dataSrc: 'custom',
                data: {
                    custom: "const _frequency = 'monthly';\n\nconst enabledPaymentMethods = data.available_payment_methods_list.filter(method => {\n  const frequencies = method.frequencies || ['once'];\n  \n  if(!method.enabled) return false;\n  if(!frequencies.includes(_frequency)) return false;\n  \n  return true;\n}).map(method => {\n  return { \n    id: method.name.toLowerCase().replace(' ', ''),\n    label: method.label, name: method.name\n  };\n});\n\nvalues = enabledPaymentMethods;"
                },
                redrawOn: 'data',
                validate: {
                    custom: "const _frequency = 'monthly';\n\nconst enabledPaymentMethods = data.available_payment_methods_list.filter(method => {\n  const frequencies = method.frequencies || ['once'];\n\n  if (!method.enabled) return false;\n  if (!frequencies.includes(_frequency)) return false;\n\n  return true;\n}).map(method => {\n  return {\n    id: method.name.toLowerCase().replace(' ', ''),\n    label: method.label,\n    name: method.name\n  };\n});\n\nif (!_.isEmpty(enabledPaymentMethods)) {\n  if (!data.default_payment_method_monthly) { \n    valid = \"A payment method is required.\";\n    return valid;\n  }\n  \n  if (!enabledPaymentMethods.some(method => method.id === data.default_payment_method_monthly)) {\n    valid = `The selected payment method is not available within the frequency: ${_frequency} .`;\n    return valid;\n  }\n\n  valid = true;\n  return valid;\n}\n\nvalid = true;"
                },
                customConditional: "const _frequency = 'monthly';\n\nconst enabledPaymentMethods = data.available_payment_methods_list.filter(method => {\n  const frequencies = method.frequencies || ['once'];\n\n  if (!method.enabled) return false;\n  if (!frequencies.includes(_frequency)) return false;\n\n  return true;\n}).map(method => {\n  return {\n    id: method.name.toLowerCase().replace(' ', ''),\n    label: method.label,\n    name: method.name\n  };\n});\n\nshow = !_.isEmpty(enabledPaymentMethods);",
                template: '<span>{{ item.label }} ({{ item.name }})</span>',
                dataType: 'string',
                valueProperty: 'id',
                refreshOn: 'available_payment_methods_list',
                clearOnHide: true,
                key: 'default_payment_method_monthly',
                type: 'select',
                input: true
            },
            {
                label: 'Default payment method for quarterly payments',
                widget: 'choicesjs',
                uniqueOptions: true,
                tableView: true,
                dataSrc: 'custom',
                data: {
                    custom: "const _frequency = 'quarterly';\n\nconst enabledPaymentMethods = data.available_payment_methods_list.filter(method => {\n  const frequencies = method.frequencies || ['once'];\n  \n  if(!method.enabled) return false;\n  if(!frequencies.includes(_frequency)) return false;\n  \n  return true;\n}).map(method => {\n  return { \n    id: method.name.toLowerCase().replace(' ', ''),\n    label: method.label, name: method.name\n  };\n});\n\nvalues = enabledPaymentMethods;"
                },
                redrawOn: 'data',
                validate: {
                    custom: "const _frequency = 'quarterly';\n\nconst enabledPaymentMethods = data.available_payment_methods_list.filter(method => {\n  const frequencies = method.frequencies || ['once'];\n\n  if (!method.enabled) return false;\n  if (!frequencies.includes(_frequency)) return false;\n\n  return true;\n}).map(method => {\n  return {\n    id: method.name.toLowerCase().replace(' ', ''),\n    label: method.label,\n    name: method.name\n  };\n});\n\nif (!_.isEmpty(enabledPaymentMethods)) {\n  if (!data.default_payment_method_quarterly) {\n valid = \"A payment method is required.\";\n    return valid;\n  }\n  \n  if (!enabledPaymentMethods.some(method => method.id === data.default_payment_method_quarterly)) {\n    valid = `The selected payment method is not available within the frequency: ${_frequency} .`;\n    return valid;\n  }\n\n  valid = true;\n  return valid;\n}\n\nvalid = true;"
                },
                customConditional: "const _frequency = 'quarterly';\n\nconst enabledPaymentMethods = data.available_payment_methods_list.filter(method => {\n  const frequencies = method.frequencies || ['once'];\n\n  if (!method.enabled) return false;\n  if (!frequencies.includes(_frequency)) return false;\n\n  return true;\n}).map(method => {\n  return {\n    id: method.name.toLowerCase().replace(' ', ''),\n    label: method.label,\n    name: method.name\n  };\n});\n\nshow = !_.isEmpty(enabledPaymentMethods);",
                template: '<span>{{ item.label }} ({{ item.name }})</span>',
                dataType: 'string',
                valueProperty: 'id',
                refreshOn: 'available_payment_methods_list',
                clearOnHide: true,
                key: 'default_payment_method_quarterly',
                type: 'select',
                input: true
            },
            {
                label: 'Default payment method for yearly payments',
                widget: 'choicesjs',
                uniqueOptions: true,
                tableView: true,
                dataSrc: 'custom',
                data: {
                    custom: "const _frequency = 'yearly';\n\nconst enabledPaymentMethods = data.available_payment_methods_list.filter(method => {\n  const frequencies = method.frequencies || ['once'];\n  \n  if(!method.enabled) return false;\n  if(!frequencies.includes(_frequency)) return false;\n  \n  return true;\n}).map(method => {\n  return { \n    id: method.name.toLowerCase().replace(' ', ''),\n    label: method.label, name: method.name\n  };\n});\n\nvalues = enabledPaymentMethods;"
                },
                redrawOn: 'data',
                validate: {
                    custom: "const _frequency = 'yearly';\n\nconst enabledPaymentMethods = data.available_payment_methods_list.filter(method => {\n  const frequencies = method.frequencies || ['once'];\n\n  if (!method.enabled) return false;\n  if (!frequencies.includes(_frequency)) return false;\n\n  return true;\n}).map(method => {\n  return {\n    id: method.name.toLowerCase().replace(' ', ''),\n    label: method.label,\n    name: method.name\n  };\n});\n\nif (!_.isEmpty(enabledPaymentMethods)) {\n  if (!data.default_payment_method_yearly) { \n    valid = \"A payment method is required.\";\n    return valid;\n  }\n  \n  if (!enabledPaymentMethods.some(method => method.id === data.default_payment_method_yearly)) {\n    valid = `The selected payment method is not available within the frequency: ${_frequency} .`;\n    return valid;\n  }\n\n  valid = true;\n  return valid;\n}\n\nvalid = true;"
                },
                customConditional: "const _frequency = 'yearly';\n\nconst enabledPaymentMethods = data.available_payment_methods_list.filter(method => {\n  const frequencies = method.frequencies || ['once'];\n\n  if (!method.enabled) return false;\n  if (!frequencies.includes(_frequency)) return false;\n\n  return true;\n}).map(method => {\n  return {\n    id: method.name.toLowerCase().replace(' ', ''),\n    label: method.label,\n    name: method.name\n  };\n});\n\nshow = !_.isEmpty(enabledPaymentMethods);",
                template: '<span>{{ item.label }} ({{ item.name }})</span>',
                dataType: 'string',
                valueProperty: 'id',
                refreshOn: 'available_payment_methods_list',
                clearOnHide: true,
                key: 'default_payment_method_yearly',
                type: 'select',
                input: true
            },
            {
                label: 'Payment Methods',
                key: 'available_payment_methods_list',
                disableAddingRemovingRows: true,
                templates: {
                    header: '' +
                        '<div class="row">' +
                        '<div class="col-sm-1"></div>' +
                        '  {% util.eachComponent(components, function(component) { %} ' +
                        '   {% if (!component.hideInTable) { %}' +
                        '    <div class="{{ component.span }}">' +
                        '      <strong>{{ component.label }}</strong>' +
                        '    </div>' +
                        '        {% } %}' +
                        '  {% }) %}' +
                        '</div>',
                    row: '' +
                        '<div class="row">' +
                        '<div class="col-sm-1">' +
                        ' <button data-key="editgrid-defaultValue" class="formio-drag-button btn btn-default fa fa-bars" type="button"></button>' +
                        ' </div>' +
                        '  {% util.eachComponent(components, function(component) { %}' +
                        '     {% if (!component.hideInTable) { %}' +
                        '       <div class="{{ component.span }}">' +
                        '         {% if (typeof row[component.key] === "boolean") { %}' +
                        '           <i class="fa fa-{{ (row[component.key] ? "check" : "times") }}"></i>' +
                        '         {% } else { %}' +
                        '           {{ row[component.key] }}' +
                        '         {% } %}' +
                        '       </div>' +
                        '     {% } %}' +
                        '  {% }) %}' +
                        '  <div class="col-sm-2">' +
                        '    <div class="btn-group pull-right">' +
                        '      <div class="btn btn-default btn-sm editRow"><i class="fa fa-edit"></i></div>' +
                        '    </div>' +
                        '  </div>' +
                        '</div>',
                    footer: '',
                },
                type: 'rowgrid',
                components: [
                    {
                        label: 'Columns Name-Label',
                        columns: [
                            {
                                components: [
                                    {
                                        label: 'Name',
                                        key: 'name',
                                        input: false,
                                        type: 'textfield',
                                        tableView: true,
                                        tooltip: 'Data representation of the payment method',
                                        span: 'col-sm-3'
                                    },
                                ],
                                width: 4,
                                offset: 0,
                                push: 0,
                                pull: 0,
                                size: 'md',
                                currentWidth: 6,
                            },
                            {
                                components: [
                                    {
                                        type: 'textfield',
                                        label: 'Label',
                                        key: 'label',
                                        input: true,
                                        tableView: true,
                                        calculateValue: 'value = row.name',
                                        allowCalculateOverride: true,
                                        span: 'col-sm-4'
                                    },
                                ],
                                width: 8,
                                offset: 0,
                                push: 0,
                                pull: 0,
                                size: 'md',
                                currentWidth: 6,
                            },
                        ],
                        key: 'columns_name_label',
                        type: 'columns',
                        input: false,
                        tableView: false,
                    },
                    {
                        type: 'checkbox',
                        label: 'Enabled',
                        key: 'enabled',
                        defaultValue: false,
                        hideInTable: false,
                        input: true,
                        weight: 150,
                        tooltip: 'Enables this payment method',
                        span: 'col-sm-2'
                    },
                    {
                        title: 'Settings',
                        collapsible: true,
                        key: 'settingsPanel',
                        type: 'panel',
                        label: 'Panel',
                        collapsed: true,
                        input: false,
                        tableView: false,
                        hideInTable: true,
                        components: [
                            {
                                label: 'Image',
                                applyMaskOn: 'change',
                                tableView: true,
                                key: 'image',
                                customConditional: 'show = false;\n\nif(row.settingFields && row.settingFields.includes(component.key)) {\n  show = true;\n}',
                                type: 'textfield',
                                input: true,
                                hideInTable: true,
                            },
                            {
                                label: 'Frequencies',
                                widget: 'choicesjs',
                                tableView: false,
                                multiple: true,
                                hideInTable: true,
                                customConditional: 'show = false;\n\nif(row.settingFields && row.settingFields.includes(component.key)) {\n  show = true;\n}',
                                validate: {
                                    required: true,
                                    onlyAvailableItems: true
                                },
                                data: {
                                    values: [
                                        {
                                            label: 'Once',
                                            value: 'once'
                                        },
                                        {
                                            label: 'Monthly',
                                            value: 'monthly'
                                        },
                                        {
                                            label: 'Quarterly',
                                            value: 'quarterly'
                                        },
                                        {
                                            label: 'Yearly',
                                            value: 'yearly'
                                        }
                                    ]
                                },
                                key: 'frequencies',
                                type: 'select',
                                input: true
                            },
                            {
                                label: 'Description',
                                applyMaskOn: 'change',
                                customConditional: 'show = false;\n\nif(row.settingFields && row.settingFields.includes(component.key)) {\n  show = true;\n}',
                                hideInTable: true,
                                autoExpand: true,
                                tableView: true,
                                key: 'description',
                                type: 'textarea',
                                input: true
                            },
                            {
                                label: 'Display Type',
                                customConditional: 'show = false;\n\nif(row.settingFields && row.settingFields.includes(component.key)) {\n  show = true;\n}',
                                hideInTable: true,
                                validate: {
                                    required: true
                                },
                                widget: 'html5',
                                tableView: true,
                                data: {
                                    values: [
                                        {
                                            label: 'Select',
                                            value: 'select'
                                        },
                                        {
                                            label: 'Radio',
                                            value: 'radio'
                                        }
                                    ]
                                },
                                key: 'displayType',
                                type: 'select',
                                input: true,
                                defaultValue: 'select'
                            },
                            {
                                label: 'Options',
                                customConditional: 'show = false;\n\nif(row.settingFields && row.settingFields.includes(component.key)) {\n  show = true;\n}',
                                reorder: true,
                                addAnotherPosition: 'bottom',
                                layoutFixed: false,
                                enableRowGroups: false,
                                initEmpty: true,
                                tableView: false,
                                hideInTable: true,
                                key: 'options',
                                type: 'datagrid',
                                input: true,
                                components: [
                                    {
                                        label: 'Image',
                                        applyMaskOn: 'change',
                                        tableView: true,
                                        key: 'image',
                                        type: 'textfield',
                                        input: true,
                                        hideInTable: true,
                                    },
                                    {
                                        label: 'Label',
                                        applyMaskOn: 'change',
                                        tableView: true,
                                        key: 'label',
                                        type: 'textfield',
                                        input: true,
                                        hideInTable: true,
                                    },
                                    {
                                        label: 'Value',
                                        applyMaskOn: 'change',
                                        tableView: true,
                                        key: 'value',
                                        type: 'textfield',
                                        input: true,
                                        hideInTable: true,
                                    },
                                ]
                            },
                            {
                                label: 'Fields',
                                customConditional: 'show = false;\n\nif(row.settingFields && row.settingFields.includes(component.key)) {\n  show = true;\n}',
                                reorder: true,
                                addAnotherPosition: 'bottom',
                                layoutFixed: false,
                                enableRowGroups: false,
                                initEmpty: true,
                                tableView: false,
                                hideInTable: true,
                                key: 'multiField',
                                type: 'datagrid',
                                input: true,
                                components: [
                                    {
                                        label: 'Name',
                                        applyMaskOn: 'change',
                                        tableView: true,
                                        key: 'name',
                                        type: 'textfield',
                                        input: true,
                                        hideInTable: true,
                                    },
                                    {
                                        label: 'Label',
                                        applyMaskOn: 'change',
                                        tableView: true,
                                        key: 'label',
                                        type: 'textfield',
                                        input: true,
                                        hideInTable: true,
                                    },
                                    {
                                        label: 'Placeholder',
                                        applyMaskOn: 'change',
                                        tableView: true,
                                        key: 'placeholder',
                                        type: 'textfield',
                                        input: true,
                                        hideInTable: true,
                                    },
                                    {
                                        label: 'Required',
                                        applyMaskOn: 'change',
                                        tableView: true,
                                        key: 'required',
                                        type: 'checkbox',
                                        input: true,
                                        hideInTable: true,
                                    },
                                    {
                                        label: 'Hidden',
                                        applyMaskOn: 'change',
                                        tableView: true,
                                        key: 'hidden',
                                        type: 'checkbox',
                                        input: true,
                                        hideInTable: true,
                                    },
                                ]
                            },
                        ]
                    },
                    {
                        type: 'hidden',
                        label: 'Setting Fields (hidden)',
                        key: 'settingFields',
                        input: false,
                        hideInTable: true,
                        disabled: true,
                        tableView: true,
                    }
                ],
            },
            {
                key: 'redrawOn',
                ignore: true,
            },
            {
                key: 'clearOnHide',
                ignore: true,
            },
            {
                key: 'multiple',
                ignore: true
            },
            {
                key: 'allowCalculateOverride',
                ignore: true,
            },
            {
                key: 'defaultValue',
                ignore: true
            },
            {
                key: 'persistent',
                ignore: true
            },
            {
                key: 'protected',
                ignore: true
            },
            {
                key: 'dbIndex',
                ignore: true
            },
            {
                key: 'calculateServer',
                ignore: true
            },
            {
                key: 'calculateValuePanel',
                ignore: true
            },
            {
                key: 'customDefaultValuePanel',
                ignore: true
            },
            {
                key: 'encrypted',
                ignore: true,
            },
        ],
    },
];
